import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { theme } from '@fiverr-private/theme';
import { appTranslate } from '../../../i18n';

export const StepEnd = () => (
    <Stack direction="column" gap="6" alignItems="center" width="100%">
        {/* mobile title (32px) */}
        <Typography
            as="h2"
            fontWeight="light"
            color="white"
            hidden={{ default: false, md: true }}
            letterSpacing="-1.92px"
            textAlign="center"
            style={{ fontSize: '32px', lineHeight: 1.2 }}
        >
            {appTranslate('unusual_way_wizard.end.title')}
        </Typography>
        {/* desktop title (54px) */}
        <Typography
            as="h2"
            fontWeight="light"
            color="white"
            hidden={{ default: true, md: false }}
            letterSpacing="-1.92px"
            textAlign="center"
            style={{ fontSize: '54px', lineHeight: 1.1 }}
        >
            {appTranslate('unusual_way_wizard.end.title')}
        </Typography>

        {/* mobile subtext (18px) */}
        <Typography
            as="p"
            fontWeight="normal"
            hidden={{ default: false, md: true }}
            letterSpacing="-0.72px"
            textAlign="center"
            style={{ fontSize: '18px', lineHeight: 1.5, color: theme.colors.grey_700 }}
        >
            {appTranslate('unusual_way_wizard.end.subtext')}
        </Typography>
        {/* desktop subtext (24px) */}
        <Typography
            as="p"
            fontWeight="normal"
            hidden={{ default: true, md: false }}
            letterSpacing="-0.24px"
            textAlign="center"
            style={{ fontSize: '24px', lineHeight: 1.4, color: theme.colors.grey_700 }}
        >
            {appTranslate('unusual_way_wizard.end.subtext')}
        </Typography>

        <Button
            colorScheme="white"
            size="lg"
            onClick={() => window.location.assign(pathfinder('jobs_page_jobs'))}
            fullWidth={{ default: true, md: false }}
            style={{ borderRadius: 9999 }}
            marginTop="6"
        >
            {`← ${appTranslate('unusual_way_wizard.end.cta')}`}
        </Button>
    </Stack>
);
